module.exports = __webpack_public_path__ + "img/logo_dark.f59c8cf5.png";